import { api, ApiError } from "@/api/api";
import { Prompt } from "@/api/prompts-types";
import { PaginatedData, PaginationParams } from "@/api/utils";
import { useQuery } from "@tanstack/react-query";

export function usePrompts(params?: PaginationParams) {
  return useQuery<PaginatedData<Prompt>, ApiError>({
    queryKey: ["GET", "prompts", params?.pageSize, params?.page],
    queryFn: () => api.prompts.get(params),
  });
}

export function useAllPrompts() {
  return usePrompts({ page: 0, pageSize: 1000 });
}
